import FieldList from "components/common/FieldList";
import Header from "components/common/Header";
import useAlert from "hooks/useAlert";
import { useNavigate } from "react-router-dom";
import useToken from "hooks/useToken";
import withAuth from "hocs/withAuth";
import withPermission from "hocs/withPermission";
import WarrantyServices from "services/taylormadeWarranty";

type TCreateDealers = {
  name: string;
};

const CreateDealers = () => {
  const navigate = useNavigate();
  const { token } = useToken();
  const { onAlert } = useAlert();

  const onSubmit = (data: any) => {
    let dataProps: TCreateDealers = data;

    WarrantyServices.createDealer(token as string, {
      ...dataProps,
    })
      .then((res) => {
        onAlert("success", "สร้าง Dealers สำเร็จ");
        navigate("/taylormade/dealers/list");
      })
      .catch((err) => {
        onAlert("error", err.response.data.message);
      });
  };

  return (
    <>
      <Header
        title="Create a new Dealers"
        breadcrumbs={[
          {
            label: "Dealers",
            href: "/taylormade/dealers/list",
          },
          {
            label: "New dealers",
          },
        ]}
      />
      <FieldList
        type="create"
        onSubmit={onSubmit}
        fields={[
          {
            label: "Dealers Name",
            type: "text",
            name: "name",
            inputOptions: {
              required: "กรุณากรอกชื่อ Dealers",
            },
            col: 6,
          },
        ]}
        onBack={() => navigate("/taylormade/dealers/list")}
      />
    </>
  );
};

export default withAuth(
  withPermission(CreateDealers, "MANAGE_TAYLORMADE_WARRANTY"),
);
